import { Inject, Injectable, InjectionToken } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
export const defaultTimeout = 720000000;

@Injectable()
export class TimeOutInterceptorService implements HttpInterceptor {
  constructor(
    @Inject(DEFAULT_TIMEOUT)
    protected readonly _defaultTimeout: number,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const timeOutValue = +req.headers.get('timeout') || this._defaultTimeout;
    req.headers.delete('timeout');
    // const timeOutValueNumeric = Number(timeOutValue);
    return next.handle(req).pipe(timeout(timeOutValue));
  }
}
